import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {
  documentCollectionType,
  idToTitleMapType,
  issuesFetchParamsType,
  issueWrapperArrayType,
  locationsTreeNodesType,
  oxygenType,
  oxygenUserType
} from '../../constants/proptype-validation';
import ProjectListMatrixTableContainer from './ProjectListMatrixTableContainer';
import lodashGet from 'lodash/get';
import {issueLink} from '../../utils/issues-helpers';
import {PAGE_PARAMS, SORTING_PARAMS} from '../../constants/issue-query-params';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';

class ProjectList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentSort: this.getSortFromFetchParams(props.fetchParams)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      lodashGet(nextProps, `fetchParams.queryParams.${SORTING_PARAMS.SORT}`) !==
      lodashGet(this.props, `fetchParams.queryParams.${SORTING_PARAMS.SORT}`)
    ) {
      this.setState({currentSort: this.getSortFromFetchParams(nextProps.fetchParams)});
    }
  }

  getSortFromFetchParams(fetchParams) {
    let sortField = lodashGet(fetchParams, `queryParams.${SORTING_PARAMS.SORT}`, ISSUE_ATTRIBUTE_NAMES.ID);
    let isAscending = true;

    if (sortField.startsWith('-')) {
      sortField = sortField.substring(1);
      isAscending = false;
    }

    return {sortField, isAscending};
  }

  getFetchParamFromCurrentSort() {
    const {currentSort} = this.state;
    const dash = currentSort.isAscending ? '' : '-';

    return `${dash}${currentSort.sortField}`;
  }

  handleSortChange(sort) {
    const newSort = this.getFetchParamFromCurrentSort() === sort ? `-${sort}` : sort;

    this.props.setQueryParamsAction({[SORTING_PARAMS.SORT]: newSort, [PAGE_PARAMS.OFFSET]: 0});
  }

  handleTableRowClick({attributes}) {
    const {changeLocationAction} = this.props;
    changeLocationAction(`/project/${TYPE_QUALITY_ISSUES}/${attributes.id}`);
  }

  render() {
    const {
      issues,
      documentCollection,
      navigateToIssueInDocumentAction,
      fetchingIssuesUrns,
      isLocationsTreeLoading,
      isLocationsLoadingError,
      locationsTreeNodes,
      rootCauseEntitiesMap,
      issueTypesAndSubTypesTitleMap,
      currentUser,
      oxygen,
      isMinimalTableColumns,
      children,
      checklistCollection,
      fetchingChecklistInstances
    } = this.props;

    const rowLinkEnabled = typeof issueLink.func === 'function';

    return (
      <div className="ProjectList">
        <ProjectListMatrixTableContainer
          tableData={issues}
          currentSort={this.state.currentSort}
          onSort={this.handleSortChange.bind(this)}
          onRowClick={this.handleTableRowClick.bind(this)}
          documentCollection={documentCollection}
          fetchingIssuesUrns={fetchingIssuesUrns}
          issueTypesAndSubTypesTitleMap={issueTypesAndSubTypesTitleMap}
          isLocationsTreeLoading={isLocationsTreeLoading}
          isLocationsLoadingError={isLocationsLoadingError}
          locationsTreeNodes={locationsTreeNodes}
          rootCauseEntitiesMap={rootCauseEntitiesMap}
          navigateToIssueInDocumentAction={navigateToIssueInDocumentAction}
          rowLinkEnabled={rowLinkEnabled}
          isMinimalTableColumns={isMinimalTableColumns}
          currentUser={currentUser}
          oxygen={oxygen}
          checklistCollection={checklistCollection}
          fetchingChecklistInstances={fetchingChecklistInstances}
        >
          {children}
        </ProjectListMatrixTableContainer>
      </div>
    );
  }
}

ProjectList.displayName = 'ProjectList';

ProjectList.propTypes = {
  fetchParams: issuesFetchParamsType.isRequired,
  documentCollection: documentCollectionType.isRequired,
  fetchingIssuesUrns: PropTypes.array,
  issues: issueWrapperArrayType.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  setQueryParamsAction: PropTypes.func.isRequired,
  navigateToIssueInDocumentAction: PropTypes.func.isRequired,
  isLocationsTreeLoading: PropTypes.bool,
  isLocationsLoadingError: PropTypes.bool,
  locationsTreeNodes: locationsTreeNodesType,
  rootCauseEntitiesMap: PropTypes.object,
  issueTypesAndSubTypesTitleMap: idToTitleMapType.isRequired,
  isMinimalTableColumns: PropTypes.bool,
  currentUser: oxygenUserType,
  oxygen: oxygenType.isRequired,
  children: PropTypes.node,
  checklistCollection: PropTypes.object.isRequired,
  fetchingChecklistInstances: PropTypes.array
};

export default ProjectList;
